import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import PageBackButton from "../../components/PageBackButton";
import ProfileSectionHeaderValue from "./ProfileSectionHeaderValue";
import Box from "../../components/Box";
import Dependents from "./Dependents";
import ResponsiveTable from "../../components/ResponsiveTable";
import { fetchUserData, getUsersPassport } from "../../services/userServices";
import {
  getFormattedDependentsInformation,
  getFormattedPersonalInfo,
  getFormattedJobInfo,
  isValidUrl,
} from "../../helper";
import { useLoaderContext } from "../../contexts/loaderContext";
import ErrorModal from "../../components/ErrorSuccessModal/ErrorModal";
import { useProfileContext } from "../../contexts/ProfileContext";

const MyProfile = () => {
  const { setLoader } = useLoaderContext();
  const navigate = useNavigate();
  const [dependentsData, setDependentsData] = useState([]);
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [jobInfoData, setJobInfoData] = useState({});
  const [passportPdfs, setPassportPdfs] = useState();
    const { profile, setProfile } = useProfileContext();
  
  let passportInter = passportPdfs;

  useEffect(() => {
    if(!profile.personId) return;

    // fetchPassportPdfs();
    fetchEmployeeData();
  }, [profile.personId]);


  const columns = [
    {
      path: "firstName",
      label: "First Name",
    },
    {
      path: "lastName",
      label: "Last Name",
    },
    {
      path: "relationship",
      label: "Relationship",
    },
    {
      path: "sponsorshipData",
      label: "Sponsorship",
      content: (data) => (
        <div style={{width:'200px'}}
        >
          {`${data.sponsorshipData}`}
        </div>
      ),
    },

    {
      path: "age",
      label: "DOB",
      content: (data) => (
        <div style={{width:'125px'}}
        >
          {`${data.dob} (${data.age})`}
        </div>
      ),
    },
    {
      path: "passportNumber",
      label: "Passport Number",
    },
 
    {
      path: "passportExpirationDate",
      label: "Passport Expiry",
      content: (data) => (
        <PassportExpiry
          color={new Date(data.passportExpirationDate) > new Date() ? "black" : "red"}
          style={{width:'125px'}}
        >
          {data.passportExpirationDate}
        </PassportExpiry>
      ),
    },
    {
      path: "passportPdf",
      label: "Passport Document",
      content: (data) => (
        <>
          {isValidUrl(data?.passportPdf) ? (
            <a href={data?.passportPdf}>{data.firstName.toLowerCase()}.pdf</a>
          ) : (
            "Not Available"
          )}
        </>
      ),
    },
  ];

  const fetchEmployeeData = async () => {
    setLoader(true);
    try {
      // let { data } = await fetchUserData();
      let data = { data: profile, code: 200 };
      let response = await getUsersPassport();

      console.log(data);
      if (data.code === 200) {
        setLoader(false);
        passportInter = response.data.data;
        setPassportPdfs(response.data.data);
        let formattedDependentsDetails = getFormattedDependentsInformation(
          data?.data.personRelationship,
          response.data.data
        );
        let formattedPersonalInfoDetails = getFormattedPersonalInfo(data?.data);
        let formattedJobInfo = getFormattedJobInfo(data?.data);
        setProfileData(formattedPersonalInfoDetails);
        setJobInfoData(formattedJobInfo);
        setDependentsData(formattedDependentsDetails);
      }
    } catch (error) {
      setLoader(false);
      console.log("error", error);
      setBackendErrorMsg(error.message);
    }
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  const fetchPassportPdfs = async () => {
    try {
      let response = await getUsersPassport();
      if (response.status === 200) {
        passportInter = response.data.data;
        setPassportPdfs(response.data.data);
        // console.log(passportInter);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <ProfileContainer>
      <PageBackButton label="My Profile" handleClick={() => navigate(-1)} />
      <ProfileSectionWrapper gap="1.25rem">
        <Box boxPadding="1.625rem 2.063rem 2.875rem" boxBorder="1.25rem">
          <ProfileSectionHeaderValue
            boxMainHeader="Personal Information"
            templateColumnsForBiggerScreens="4"
            data={profileData}
          />
        </Box>
      </ProfileSectionWrapper>
      {dependentsData && dependentsData.length > 0 && (
        <ProfileSectionWrapper gap="1.25rem">
          <Box boxPadding="1.625rem 2.063rem 2rem" boxBorder="1.25rem">
            <Dependents
              boxMainHeader="Dependents"
              columns={columns}
              data={dependentsData}
            />
            <ResponsiveTable data={dependentsData} columns={columns} />
          </Box>
        </ProfileSectionWrapper>
      )}
      <ProfileSectionWrapper gap="1.25rem">
        <Box boxPadding="1.625rem 2.063rem 2.875rem" boxBorder="1.25rem">
          <ProfileSectionHeaderValue
            boxMainHeader="Job Info"
            templateColumnsForBiggerScreens="4"
            data={jobInfoData}
          />
        </Box>
      </ProfileSectionWrapper>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
    </ProfileContainer>
  );
};

const ProfileContainer = styled.div`
  padding: 3.75rem 2.5rem;
`;

const ProfileSectionWrapper = styled.div`
  padding: 1.25rem 0rem;
  display: flex;
  gap: ${(props) => props.gap};

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const ProfileHeaderWrapper = styled.div`
  padding-top: 1.125rem;
  display: grid;
  grid-template-columns: repeat(
    ${(props) => props.templateColumnsForBiggerScreens},
    1fr
  );
  gap: 2.875rem 2.875rem;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 481px) and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
`;
export const PassportExpiry = styled.div`
  color: ${(props) => props.color};
  font-size: 1.125rem;
  font-weight: 600;
`;
export default MyProfile;
